export const AVG_REVIEW_COLUMNS = {
  AVG_REVIEW_PERIOD: "avg_review_period",
  AVG_REVIEW_BEGINNING: "avg_review_beginning",
  AVERAGE: "average",
  AVERAGE_TOTAL: "average_total"
};
